interface IconProps {
  className?: string;
}

const PhoneIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1608_3661)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M23.226 17.878v3.311a2.21 2.21 0 0 1-1.504 2.1 2.2 2.2 0 0 1-.908.108 21.9 21.9 0 0 1-9.546-3.389 21.55 21.55 0 0 1-6.637-6.624 21.8 21.8 0 0 1-3.395-9.571 2.2 2.2 0 0 1 1.309-2.218c.28-.124.585-.188.892-.189h3.318a2.215 2.215 0 0 1 2.213 1.9c.14 1.059.4 2.1.774 3.101a2.2 2.2 0 0 1-.498 2.33L7.84 10.139a17.7 17.7 0 0 0 6.637 6.624l1.405-1.403a2.22 2.22 0 0 1 2.334-.496 14.2 14.2 0 0 0 3.108.772 2.214 2.214 0 0 1 1.903 2.242"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1608_3661">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PhoneIcon;
